// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3136c435","787":"15ab848f","910":"abafc169"}[chunkId] + ".chunk.js";
};